import { api } from '@/lib/api/client'
import type { Subscription } from '@/features/billing/types/billing'

/** `GET /organizations/{organization}/subscriptions` lists its subscriptions, one per product. */
export async function getOrganizationSubscriptions(
  organizationId: number,
): Promise<Subscription[]> {
  const { data } = await api.get<{ data: Subscription[] }>(
    `/organizations/${organizationId}/subscriptions`,
  )

  return data.data
}
